// Invoice B2C Frontend Configuration

export const config = {
    // Invoice Management API (shared backend)
    API_URL: process.env.REACT_APP_API_URL || 'http://localhost:5004',
};

export default config;
